import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus5() {
  return (
    <BusDetailsCard
      busId="bus5"
      title="Bus 5 - Route Details"
      busName="Bus 5"
      vehicleNo="TN74E5234"
      backTo="/?buses=1"
    />
  );
}